const img = require('./SingleDoor.svg'); export default img;